import {mailReg, numberReg, nameReg} from "./const";

export function isValidTel(telInput) {
    return telInput.value.length === telInput.maxLength;
}

export function isValidMail(mailInput) {
    mailInput.value = mailInput.value.trim();
    return mailReg.test(mailInput.value);
}

export function isValidNumber(numberInput) {
    return numberReg.test(numberInput.value);
}

export function isValidName(nameInput) {
    nameInput.value = nameInput.value.trim();
    return nameReg.test(nameInput.value);
}